 
import _ from 'underscore'
import service from '../service/recharge'
import CONSTANT from '../constant/recharge'

const getRechargeDetail = ({ commit, state }, options) => {
  return new Promise((resolve, reject) => {
    return service.getRechargeDetail(options).then(data => {
      if (_.isEmpty(data)) {
        resolve({})
        commit(CONSTANT.RECHARGE_GET_DETAIL_ERROR_EMPTY)
        return {}
      }
      resolve(data)
      if (_.isEmpty(options.rechargeNum)) {
        commit(CONSTANT.RECHARGE_GET_DETAIL_SUCCESS, { data, type: options.rechargeType })
      }
      return data
    }, e => {
      reject(e)
      commit(CONSTANT.RECHARGE_GET_DETAIL_ERROR, e)
    })
  })
}
const getRecommendProduct = ({ commit }, query) => {
  return new Promise((resolve, reject) => {
    return service.getRecommendProduct(query).then(data => {
      if (_.isEmpty(data.data)) {
        resolve(data)
        commit(CONSTANT.RECHARGE_GET_RECOMMEND_LIST_EMPTY)
        return data
      }
      resolve(data)
      commit(CONSTANT.RECHARGE_GET_RECOMMEND_LIST_SUCCESS, data)
      return data
    }, e => {
      reject(e)
      commit(CONSTANT.RECHARGE_GET_RECOMMEND_LIST_ERROR, e)
    })
  })
}
export default {
  getRechargeDetail,
  getRecommendProduct,
}
